import moment from 'moment';
export default function isValidDate(value) {
    return moment(value, 'DD.MM.YYYY', true).isValid();
}
